// extracted by mini-css-extract-plugin
export default {"registry-totals-container":"fbyR","registryTotalsContainer":"fbyR","registry-total-box":"XR8l","registryTotalBox":"XR8l"};